// notificationCatalog.js — the built-in ("system") notification flows, surfaced
// in the admin Notifications page for visibility and limited editing. Pure data
// (no server-only imports) so the frontend can import it via @shared too.
//
//   editable: 'recipients' — admin may toggle enabled + edit who is notified
//             'none'       — locked: routing is intrinsic to the flow

// Treatment-based extra recipients added to the case_submitted notification, on
// top of the configured base recipients. Currently a fixed routing (a hardcode);
// surfaced in the admin Notifications page so it's visible, not hidden in code.
export const TREATMENT_SUBMIT_NOTIFY = Object.freeze({
  AWI: ['nickyru@therapieclinic.com'],
  LHR: ['alices@therapieclinic.com'],
});

export const SYSTEM_NOTIFICATIONS = Object.freeze([
  {
    id: 'system.case_submitted',
    trigger: 'case_submitted',
    label: 'New case submitted',
    description: 'Sent to the configured recipients whenever any case is created.',
    editable: 'recipients',
    configKey: 'caseSubmittedNotification',
  },
  {
    id: 'system.signoff_complete',
    trigger: 'requirement_signed_off',
    label: 'Sign-off completed → requester',
    description: 'The person who requested a sign-off is automatically notified when it is completed. Routing is per-request and cannot be retargeted.',
    editable: 'none',
  },
]);
